/* Google Tag Manager (GTM) Tracking */
import TagManager, { TagManagerArgs, DataLayerArgs } from 'react-gtm-module'
import { REACT_APP_BLAZE } from 'env'

interface trackingArgs extends DataLayerArgs {
  events?: TagManagerArgs['events']
}

export const gtmTracking = (trackingArgs: trackingArgs = {}) => {
  const isBlaze = REACT_APP_BLAZE === true

  let tagManagerArgs: TagManagerArgs = {
    gtmId: isBlaze ? 'GTM-PJ5D6SKK' : 'GTM-PFW84NL',
    ...trackingArgs,
  }

  if (process.env.REACT_APP_ENV === 'dev') {
    tagManagerArgs = {
      auth: 'K7mdsqHTf72YMwijxvmi4A',
      preview: 'env-15',
      ...tagManagerArgs,
    }
  }

  TagManager.initialize(tagManagerArgs)
}
